var angular = require( "angular" );

angular.module( "flowersApp" )
    .directive( "fancybox", require( "./FancyBoxDirective" ) )
    .directive( "cityButton", require( "./CityButtonDirective" ) )
    .directive( "closeSearch", require( "./CloseSearchDirective" ) )
    .directive( "addToCart", require( "./AddToCartDirective" ) )
    .directive( "noLink", require( "./NoLinkDirective" ) )
    .directive( "accessibleForm", require( "./AccessibleFormDirective" ) )
    .directive( "selectFirstIfOnlyOne", require( "./SelectFirstIfOnlyOne" ) );